<template>
	<div class="o-container o-container--thin registration-page">
		<change-email-form
			:submit="changeEmail"
			v-if="!showVerifyForm"
		/>
		<verify-changed-email-form
			:submit="verifyChangedEmail"
			:email="this.email"
			v-if="showVerifyForm"
		/>
	</div>
</template>

<script>
	import ChangeEmailForm from '../forms/ChangeEmailForm.vue';
	import VerifyChangedEmailForm from '../forms/VerifyChangedEmailForm.vue';
    import '../../store/modules/session/session';

	export default {
		components: {
			ChangeEmailForm,
            VerifyChangedEmailForm
		},
        data() {
            return {
                showVerifyForm: false,
				email: this.$session.has('email') ? this.$session.get('email') : ''
            }
        },
		methods: {
			changeEmail(emailData) {
				return this.$store.dispatch('user/CHANGE_EMAIL', emailData).then(() => {
				    this.email = emailData.newEmail.toLowerCase();
                    this.showVerifyForm = true;
				});
			},
            verifyChangedEmail(emailData) {
                return this.$store.dispatch('user/VERIFY_CHANGED_EMAIL', emailData).then(() => {
                    this.$router.push({
                        name: 'myAccount',
                        params: {
                            message: {
                                type: 'success',
                                value: `Your email address <strong>${emailData.email.toLowerCase()}</strong> has been updated.`
                            }
                        }
                    });
                });
            }
		}
	}
</script>
